import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Protected from "../Protected";
import VerifyDetails from "../pages/additional-details/AdditionalDetails";
import BankDetails from "../pages/bank-details/BankDetails";
import Details from "../pages/details/Details";
import IncomeVerification from "../pages/income-verification/IncomeVerification";
import EPL from "../pages/landing-page/LandingPage";
import LoanIPO from "../pages/load-ipo/LoanIPO";
import LoanAgreement from "../pages/loan-agreement/LoanAgreement";
import LoanSummary from "../pages/loan-summary/LoanSummary";
import Login from "../pages/login/Login";
import Error from "../pages/other-pages/Error";
import LoadingScreen from "../pages/other-pages/Loading_Screen";
import PageNotFound from "../pages/other-pages/Page404";
import Rejected from "../pages/other-pages/Rejected";
import ReferenceDetails from "../pages/reference-details/ReferenceDetails";
import DisbursementReverify from "../pages/disbursement-reverify/DisbursementReverify";
import ReviewDetails from "../pages/review/ReviewPage";
import Selfie from "../pages/selfie/Selfie";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Vkyc from "../pages/vkyc/Vkyc";
import DetailsVerify from "../pages/details-verify/DetailsVerify";
import Udyam from "../pages/udyam/Udyam";
import DocUpload from "../pages/doc-upload/DocUpload";
import Nstp from "../pages/nstp/Nstp";

const EplRoutes = () => {
  const { path } = useParams();
  useEffect(()=>{
    // console.log("UPSELLROUTES")
  }, [])


  // // console.log("path: ", path);
  // // console.log("path.trim(): ", path.trim());
  // // console.log("path.trim() === ('ipo'): ", path.trim() === ("ipo"));

  return (
    <>
      {path.trim() === ("error") && <Error />}
      {path.trim() === ("loading") && <LoadingScreen />}
      {path.trim() === ("pageNotFound") && <PageNotFound />}
      {path.trim() === ("index") && <EPL />}
      {path.trim() === ("login") && 
        <GoogleReCaptchaProvider reCaptchaKey="6LcVMEMpAAAAAGyFUspEvgqXUB06IVZ1vqSovoNu">
          <Login />
        </GoogleReCaptchaProvider>
      }
      {path.trim() === ("details") && (
        <Protected>
          <Details />
        </Protected>
      )}
      {path.trim() === "detailsVerify" && (
        <Protected>
          <DetailsVerify />
        </Protected>
      )}
      {path.trim() === ("income") && (
        <Protected>
          <IncomeVerification />
        </Protected>
      )}
      {path.trim() === ("ipo") && (
        <Protected>
          <LoanIPO />
        </Protected>
      )}
      {path.trim() === ("selfie") && (
        <Protected>
          <Selfie />
        </Protected>
      )}
      {path.trim() === ("verifyDetails") && (
        <Protected>
          <VerifyDetails />
        </Protected>
      )}
      {path.trim() === ("review") && (
        <Protected>
          <ReviewDetails />
        </Protected>
      )}
      {path.trim() === ("bankDetails") && (
        <Protected>
          <BankDetails />
        </Protected>
      )}
      {path.trim() === ("agreement") && (
        <Protected>
          <LoanAgreement />
        </Protected>
      )}
      {path.trim() === ("offer") && (
        <Protected>
          <LoanSummary />
        </Protected>
      )}
      {path.trim() === "verifyCompanyDetails" && (
        <Protected>
          <DisbursementReverify />
        </Protected>
      )}
      {path.trim() === ("rejected") && (
        <Protected>
          <Rejected />
        </Protected>
      )}
      {path.trim() === ("reference") && (
        <Protected>
          <ReferenceDetails />
        </Protected>
      )}
      {path.trim() === "verificationPending" && (
				<Protected>
					<Vkyc />
				</Protected>
			)}
      {path.trim() === ("udyam") && (
				<Protected>
					<Udyam />
				</Protected>
			)}
      {path.trim() === ("docUpload") && (
				<Protected>
					<DocUpload />
				</Protected>
			)}
			{path.trim() === ("nstp") && (
				<Protected>
					<Nstp />
				</Protected>
			)}
    </>
  );
}

export default EplRoutes;